import type { ProjectState, Effect } from "./types";

function clamp(n: number): number {
  return Math.max(0, Math.min(100, n));
}

/** Pure — applies every effect for real (the step the reference repo left as a dead field). */
export function applyEffects(state: ProjectState, effects: Effect[]): ProjectState {
  const next = { ...state };
  for (const effect of effects) {
    next[effect.metric] = clamp(next[effect.metric] + effect.delta);
  }
  return next;
}
